const LeadFormPanel = ({
    radius,
    primaryColor,
    leadSubmitted,
    leadEmail,
    leadMessage,
    leadSubmitting,
    leadError,
    onEmailChange,
    onMessageChange,
    onSubmit,
    onClose,
}) => (
    <div
        className="flex min-h-0 flex-1 flex-col w-[95%] mb-4 p-4 bg-white overflow-y-auto"
        style={{ borderRadius: radius }}
    >
        <div className="flex items-center justify-between mb-4">
            <span className="text-[15px] font-semibold text-gray-800">
                Contact Us
            </span>
            <button
                onClick={onClose}
                className="bg-transparent border-none cursor-pointer text-gray-500 text-sm"
            >
                Back to Chat
            </button>
        </div>

        {leadSubmitted ? (
            <div className="flex-1 flex flex-col items-center justify-center gap-3">
                <svg
                    className="w-12 h-12"
                    style={{ color: primaryColor }}
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                </svg>
                <p className="text-sm font-semibold text-gray-800">
                    Message sent!
                </p>
                <p className="text-xs text-gray-500 text-center">
                    We'll get back to you soon.
                </p>
                <button
                    onClick={onClose}
                    className="mt-2 px-5 py-2 text-white border-none cursor-pointer text-sm"
                    style={{ borderRadius: radius, backgroundColor: primaryColor }}
                >
                    Back to Chat
                </button>
            </div>
        ) : (
            <form onSubmit={onSubmit} className="flex flex-col gap-3">
                <div>
                    <label className="text-xs text-gray-700 font-medium">
                        Email *
                    </label>
                    <input
                        type="email"
                        value={leadEmail}
                        onChange={(e) => onEmailChange(e.target.value)}
                        required
                        placeholder="your@email.com"
                        className="mt-1 w-full px-[10px] py-2 text-[13px] outline-none box-border"
                        style={{
                            borderRadius: radius,
                            border: `1px solid ${primaryColor}55`,
                        }}
                    />
                </div>
                <div>
                    <label className="text-xs text-gray-700 font-medium">
                        Message (optional)
                    </label>
                    <textarea
                        value={leadMessage}
                        onChange={(e) => onMessageChange(e.target.value)}
                        rows={4}
                        placeholder="Describe your question..."
                        className="mt-1 w-full px-[10px] py-2 text-[13px] outline-none resize-none box-border"
                        style={{
                            borderRadius: radius,
                            border: `1px solid ${primaryColor}55`,
                        }}
                    />
                </div>
                {leadError && (
                    <p className="text-xs text-red-500">{leadError}</p>
                )}
                <button
                    type="submit"
                    disabled={leadSubmitting || !leadEmail.trim()}
                    className="p-[10px] text-white border-none text-[13px] font-semibold"
                    style={{
                        borderRadius: radius,
                        backgroundColor:
                            leadSubmitting || !leadEmail.trim()
                                ? "#d1d5db"
                                : primaryColor,
                        cursor:
                            leadSubmitting || !leadEmail.trim()
                                ? "not-allowed"
                                : "pointer",
                    }}
                >
                    {leadSubmitting ? "Sending..." : "Send Message"}
                </button>
            </form>
        )}
    </div>
);

export default LeadFormPanel;
